/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './CardForExpiredDocs.css';
import { Grid, Box, Typography, Divider } from '@mui/material';
import { themes } from '../../themes/themes';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../infra/hooks';
import { check_user_permission } from '../../configs/utils';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';
interface contentTileType {
  tile_value: string;
  subtitle1: string;
  IdentifierNo: any;
  Issuetitle: string;
  IssueDate: any;
  ExpDate: any;
  Expirytitle: string;
  country: string;
  onDelete?: any;
  onView?: any;
  onExpiryNotification?: any;
  onEnableExpiryNotification?: any;
  isExpiryNotification?: number;
}
const CardForExpiredDocs: React.FC<contentTileType> = ({
  tile_value,
  subtitle1,
  IdentifierNo,
  Issuetitle,
  IssueDate,
  Expirytitle,
  ExpDate,
  country,
  onDelete,
  onView,
  onExpiryNotification,
  onEnableExpiryNotification,
  isExpiryNotification,
}) => {
  const { t } = useTranslation();
  const trans = t;
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );
  return (
    <Grid container className="action-tileContainer">
      <Grid item style={{ flexGrow: 1 }}>
        <Typography
          className="title1"
          sx={{ fontSize: '0.95em', fontWeight: 'bold' }}
        >
          {tile_value}
        </Typography>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: '0.75em' }}>
              {subtitle1}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="identifierNo mx-1"
              sx={{
                fontSize: '0.75em',
                fontWeight: 'bold',
              }}
            >
              {IdentifierNo}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item style={{ marginTop: '0.09em' }}>
            <Typography className="Issuetitle" sx={{ fontSize: '0.75em' }}>
              {Issuetitle}:
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="IssueDate mx-1"
              sx={{
                fontSize: '0.875em',
                marginLeft: '0.2em',
                fontWeight: 'bold',
              }}
            >
              <DateField value={IssueDate} format={baseDateFormatting} />
            </Typography>
          </Grid>
          <Grid item>
            <Divider orientation="vertical" sx={{ marginLeft: '0.5em' }} />
          </Grid>
          <Grid item style={{ marginTop: '0.1em' }}>
            <Typography
              className="Issuetitle mx-1"
              sx={{
                color: themes.red,
                marginLeft: '0.5em',
                fontSize: '0.75em',
              }}
            >
              {Expirytitle}:
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="expdate"
              sx={{
                color: themes.red,
                fontSize: '0.875em',
                marginLeft: '0.2em',
                fontWeight: 'bold',
              }}
            >
              <DateField value={ExpDate} format={baseDateFormatting} />
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography
              className="issuecountrytitle"
              sx={{ fontSize: '0.75em' }}
            >
              {`${trans('Issue Country')}: `}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="issueCountrytitle2 mx-1"
              sx={{
                fontSize: '0.75em',
              }}
            >
              {country}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ marginTop: '1.5em', marginLeft: '0.5em' }}>
        {isExpiryNotification == 1 ? (
          <Box
            style={{
              border: '1px solid #E6E8EF',
              color: '#FF5263',
              width: '1.8125em',
              height: '1.8125em',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              borderRadius: '0.375em',
              cursor: 'pointer',
            }}
            onClick={onExpiryNotification}
          >
            <i className="lar la-bell"></i>
          </Box>
        ) : (
          <Box
            style={{
              border: '1px solid #E6E8EF',
              color: '#FF5263',
              width: '1.8125em',
              height: '1.8125em',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              borderRadius: '0.375em',
              cursor: 'pointer',
            }}
            onClick={onEnableExpiryNotification}
          >
            <i className="lar la-bell-slash"></i>
          </Box>
        )}
      </Grid>
      {check_user_permission(auth_permissions, true, 'edit') ? (
        <Grid item style={{ marginTop: '1.5em', marginLeft: '0.5em' }}>
          <Box
            style={{
              border: '1px solid #E6E8EF',
              color: '#FF5263',
              width: '1.8125em',
              height: '1.8125em',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              borderRadius: '0.375em',
              cursor: 'pointer',
            }}
            onClick={onDelete}
          >
            <i className="las la-trash-alt"></i>
          </Box>
        </Grid>
      ) : (
        <></>
      )}
      <Grid item style={{ marginTop: '1.5em', marginLeft: '0.5em' }}>
        <Box
          style={{
            border: '1px solid #E6E8EF',
            color: '#7C0E6F',
            width: '1.8125em',
            height: '1.8125em',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            borderRadius: '0.375em',
            cursor: 'pointer',
          }}
          onClick={onView}
        >
          <i className="lar la-eye"></i>
        </Box>
      </Grid>
    </Grid>
  );
};

export default CardForExpiredDocs;
